<template>
  <div
    class="resize-observer"
    tabindex="-1"
  />
</template>

<script>
import { isIE } from "@zyzgroup/core-web";

function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
  }
}

export default {
  name: "ResizeObserver",

  props: {
    emitOnMount: {
      type: Boolean,
      default: true
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    initCompat();
    this.$nextTick(() => {
      this._w = this.$el.offsetWidth;
      this._h = this.$el.offsetHeight;
      if (this.emitOnMount) {
        this.emitSize();
      }
    });
    const object = document.createElement("object");
    this._resizeObject = object;
    object.setAttribute("aria-hidden", "true");
    object.setAttribute("tabindex", -1);
    object.onload = this.addResizeHandlers;
    object.type = "text/html";
    if (!isIE) {
      object.data = "about:blank";
    }
    this.$el.appendChild(object);
  },

  beforeDestroy() {
    this.removeResizeHandlers();
  },

  methods: {
    compareAndNotify() {
      if (
        (!this.ignoreWidth && this._w !== this.$el.offsetWidth) ||
        (!this.ignoreHeight && this._h !== this.$el.offsetHeight)
      ) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },

    emitSize() {
      this.$emit("resize", {
        width: this._w,
        height: this._h
      });
    },

    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener(
        "resize",
        this.compareAndNotify
      );
      this.compareAndNotify();
    },

    removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener(
            "resize",
            this.compareAndNotify
          );
        }
        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};
</script>

<style scoped>
.resize-observer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}

/* .resize-observer >>> object */
.resize-observer :deep(object) {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: block;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}
</style>
